import React from 'react';
import { Link } from 'react-router-dom';

function Sidebar({ blogPosts }) {
  return (
    <div className="sidebar">
      <h3>Latest Posts</h3>
      <ul>
        {blogPosts.map((post) => (
          <li key={post.slug} className="sidebar-item">
            <Link to={`/blog/${post.slug}`} className="sidebar-link">
              <div className="sidebar-item-content">
                {/* Displaying the image or icon */}
                <img
                  src={post.image}
                  alt={post.title}
                  className="sidebar-item-image"
                />
                <div className="sidebar-item-text">
                  <h4>{post.title}</h4>
                  <p>{post.date}</p>
                </div>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Sidebar;
